import { FixMeLater } from '../../temporary-types';
import ACTIONS_TYPES from '../../constants/types';
import { PATHS_WITH_PARAMS } from '../../utils/paths';

interface IValidationError {
  fieldCode: string;
  message: string;
  ruleName: string;
}

export interface AppState {
  appConfigLoadStatus: boolean;
  registerAccess: boolean;
  applicationSent: boolean;
  formInitialValues: Dict<any>;
  messageFromBackend: boolean;
  loader: boolean;
  serverErrorMessage: string;
  errorPage: boolean;
  validationErrors: {
    status: boolean;
    errors: IValidationError[];
  };
  resultCode: null | string;
  urlParams: null | string;
  previewForm: boolean;
  language: string;
  appError: string | null;
  userAlreadyAvailableFormPath: string | null;
  accountRegisterUrl: string | null;
  projectImageRules?: any;
}

const initialState: AppState = {
  appConfigLoadStatus: false,
  registerAccess: false,
  applicationSent: false,
  formInitialValues: {},
  messageFromBackend: false,
  loader: false,
  projectImageRules: null,
  serverErrorMessage: '',
  errorPage: false,
  validationErrors: {
    status: false,
    errors: [],
  },
  resultCode: null,
  urlParams: null,
  previewForm: false,
  language: 'en',
  appError: null,
  userAlreadyAvailableFormPath: null,
  accountRegisterUrl: null, //PATHS_WITH_PARAMS.account_register,
};

export default function (state = initialState, action: FixMeLater): AppState {
  switch (action.type) {
    case ACTIONS_TYPES.SET_APP_CONFIG_LOAD_STATUS:
      return { ...state, appConfigLoadStatus: action.payload };

    case ACTIONS_TYPES.UNBLOCK_REGISTER_FORM: {
      const { access } = action.payload;
      return { ...state, registerAccess: access };
    }

    case ACTIONS_TYPES.SET_APPLICATION_SENT: {
      const { isSent } = action.payload;
      return { ...state, applicationSent: isSent };
    }

    case ACTIONS_TYPES.SET_MESSAGE_FROM_BACKEND: {
      return { ...state, messageFromBackend: action.payload };
    }

    case ACTIONS_TYPES.SET_FORM_INITIAL_VALUES: {
      const notNullValues = Object.entries(action.payload).reduce(
        (acc, [fieldCode, value]) => ({
          ...acc,
          [fieldCode]: value ?? '',
        }),
        {},
      );
      return { ...state, formInitialValues: notNullValues };
    }

    case ACTIONS_TYPES.SET_LOADER: {
      return { ...state, loader: action.payload };
    }

    case ACTIONS_TYPES.SET_APP_ERROR: {
      return { ...state, appError: action.payload };
    }

    case ACTIONS_TYPES.SET_VALIDATION_ERRORS: {
      const { status, errors } = action.payload;
      return { ...state, validationErrors: { status, errors } };
    }

    case ACTIONS_TYPES.SET_RESULT_CODE: {
      return { ...state, resultCode: action.payload };
    }

    case ACTIONS_TYPES.SET_SERVER_ERROR: {
      return { ...state, serverErrorMessage: action.payload };
    }
    case ACTIONS_TYPES.SET_ERROR_PAGE: {
      return { ...state, errorPage: action.payload };
    }

    case ACTIONS_TYPES.SET_URL_PARAMS: {
      return { ...state, urlParams: action.payload };
    }
    case ACTIONS_TYPES.SET_ACCOUNT_REGISTER_URL: {
      return { ...state, accountRegisterUrl: action.payload };
    }
    case ACTIONS_TYPES.SET_LANGUAGE:
      return { ...state, language: action.payload };

    case ACTIONS_TYPES.SET_PREVIEW_FORM:
      return { ...state, previewForm: true };

    case ACTIONS_TYPES.SET_PROJECT_IMAGE_RULES: {
      return { ...state, projectImageRules: action.payload };
    }

    case ACTIONS_TYPES.SET_USER_ALREADY_AVAILABLE_FORM_PATH: {
      return { ...state, userAlreadyAvailableFormPath: action.payload };
    }

    default:
      return state;
  }
}
